import logofullcomm2 from "../../img/logo-fullcomm-horizontal.svg";
import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.div}>
        <p>Powered by</p>
        <img src={logofullcomm2} alt="Fullcomm" className={styles.logo} />
      </div>
      <a
        href="https://fullcomm.io/privacidade/"
        target="_blank"
        rel="noreferrer"
        className={styles.link}
      >
        Política de Privacidade e Termos de Uso
      </a>
    </footer>
  );
};

export default Footer;
